export type DashboardTabId =
  | "overview"
  | "revenue"
  | "enrollments"
  | "operations"
  | "support"
  | "bookstore"
  | "reports";

export type DashboardTabConfig = {
  id: DashboardTabId;
  label: string;
  permissions: string[];
};

export const DASHBOARD_TABS: DashboardTabConfig[] = [
  {
    id: "overview",
    label: "Overview",
    permissions: ["dashboard.analytics.view"],
  },
  {
    id: "revenue",
    label: "Revenue & Payments",
    permissions: ["payments.main.view"],
  },
  {
    id: "enrollments",
    label: "Enrollments",
    permissions: ["users.main.view"],
  },
  {
    id: "operations",
    label: "Operations",
    permissions: [
      "users.main.view",
      "certifications.main.view",
      "transcripts.main.view",
    ],
  },
  {
    id: "support",
    label: "Support & Leads",
    permissions: [
      "tickets.main.view",
      "supportTickets.main.view",
      "supportTickets.chat.view",
    ],
  },
  {
    id: "bookstore",
    label: "Bookstore",
    permissions: ["bookstore.orders.view", "bookstore.products.view"],
  },
  {
    id: "reports",
    label: "Reports",
    permissions: ["dashboard.analytics.export", "dashboard.main.downloadReport"],
  },
];
